import { render, staticRenderFns } from "./WhatsappTemplateDialog.vue?vue&type=template&id=3a8feb68&"
import script from "./WhatsappTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./WhatsappTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports